"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setMeta = exports.sendCdnRequestTimeLog = exports.sendCdnRequestError = exports.sendNoMatchedCdnLog = exports.sendMissingLog = exports.sendFallbackLog = exports.sendInitialTimeLog = exports.sendTransformTimeLog = exports.baseSendLog = void 0;
var missKeyMap = {};
var fallbackKeyMap = {};
var normalizeTextDesc = function (params) {
    var _a = params || {}, _b = _a.text, text = _b === void 0 ? '' : _b, _c = _a.desc, desc = _c === void 0 ? '' : _c, _d = _a.id, id = _d === void 0 ? '' : _d;
    return "<<id:>>" + id + "<<text:>>" + text + "<<desc:>>" + desc;
};
var metaInfo = {};
var baseSendLog = function (params) {
    var _a;
    var ctx = (_a = window === null || window === void 0 ? void 0 : window.__kibtlog__) === null || _a === void 0 ? void 0 : _a.logger;
    var logger = ctx === null || ctx === void 0 ? void 0 : ctx.reportData;
    var sepDimension = ctx === null || ctx === void 0 ? void 0 : ctx.sepDimension;
    Object.assign(params.value, metaInfo || {});
    if (logger && sepDimension) {
        logger.bind(ctx)(sepDimension(params));
    }
};
exports.baseSendLog = baseSendLog;
var sendTransformTimeLog = function (duration, count) {
    var name = '[k18n]-格式转换时间';
    exports.baseSendLog({
        key: 'custom',
        value: {
            name: name,
            duration: duration,
            count: count,
        }
    });
};
exports.sendTransformTimeLog = sendTransformTimeLog;
var sendInitialTimeLog = function (duration) {
    var name = '[k18n]-初始化时间';
    exports.baseSendLog({
        key: 'custom',
        value: {
            name: name,
            duration: duration,
        }
    });
};
exports.sendInitialTimeLog = sendInitialTimeLog;
var sendFallbackLog = function (params) {
    if (!params.id && !params.text) {
        return;
    }
    var name = '[k18n]-文案兜底';
    var textDesc = normalizeTextDesc(params);
    if (fallbackKeyMap[textDesc]) {
        return;
    }
    fallbackKeyMap[textDesc] = true;
    exports.baseSendLog({
        key: 'custom',
        value: __assign({ name: name }, params)
    });
};
exports.sendFallbackLog = sendFallbackLog;
var sendMissingLog = function (params) {
    if (!params.id && !params.text) {
        return;
    }
    var name = '[k18n]-文案缺失';
    var textDesc = normalizeTextDesc(params);
    if (missKeyMap[textDesc]) {
        return;
    }
    missKeyMap[textDesc] = true;
    exports.baseSendLog({
        key: 'custom',
        value: __assign({ name: name }, params)
    });
};
exports.sendMissingLog = sendMissingLog;
var sendNoMatchedCdnLog = function () {
    var name = '[k18n]-未注入cdn信息';
    exports.baseSendLog({
        key: 'custom',
        value: {
            name: name,
        }
    });
};
exports.sendNoMatchedCdnLog = sendNoMatchedCdnLog;
var sendCdnRequestError = function (url, status) {
    var name = '[k18n]-cdn请求错误';
    exports.baseSendLog({
        key: 'custom',
        value: {
            name: name,
            cdnUrl: url,
            statusCode: status,
        }
    });
};
exports.sendCdnRequestError = sendCdnRequestError;
var sendCdnRequestTimeLog = function (url, ts) {
    var name = '[k18n]-cdn请求时间';
    exports.baseSendLog({
        key: 'custom',
        value: {
            name: name,
            cdnUrl: url,
            duration: ts,
        }
    });
};
exports.sendCdnRequestTimeLog = sendCdnRequestTimeLog;
var setMeta = function (obj) {
    if (obj && typeof obj === 'object') {
        metaInfo = obj;
    }
};
exports.setMeta = setMeta;
